<template>
  <div class="wrapper">
    <transition name="slide-fade">
      <div v-if="showEndgame" class="new-report">
        <h2>⚠️ Final progress report received</h2>
        <p>Pilot has received "All Clear" report.</p>
        <p>Commit final log and terminate LOCKDOWN Protocol.</p>
      </div>
    </transition>
    <h2>Progress Reports</h2>
    <p v-if="unlockedReports.length === 0">No communications received.</p>
    <div v-else>
      <div v-for="(record, i) in reports" :key="i">
        <TextRecord :record="record" :even="i % 2 === 0" fullReport />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import TextRecord from '@/components/TextRecord';

export default {
  name: 'Reports',
  components: {
    TextRecord,
  },
  computed: {
    reports() {
      return this.allLogs.filter(log => log.type === 'report').slice().reverse();
    },
    showEndgame() {
      return this.unlockedReports.length === 4;
    },
    ...mapState({
      allLogs: state => state.logs.allLogs,
      newReport: state => state.reports.newReport,
    }),
    ...mapGetters([
      'unlockedReports',
    ]),
  },
  methods: {
    ...mapMutations([
      'commitReport',
      'clearNewReport',
      'saveState',
    ]),
  },
  mounted() {
    if (this.newReport) {
      this.commitReport();
      this.clearNewReport();
      this.saveState();
    }
  },
}
</script>

<style scoped>
.new-report {
  /* height: 160px; */
  opacity: 1;
  pointer-events: all;
  border: 1px solid var(--primary-color);
  padding: 10px 30px;
  border-radius: 5px;
  margin-top: 20px;
}

.slide-fade-enter-active {
  transition: height 0.5s, opacity 0.5s 0.5s, margin-top 0s;
}
.slide-fade-leave-active {
  transition: opacity 0s, height 0s, margin-top 0s;
}
.slide-fade-enter, .slide-fade-leave-to {
  height: 0;
  opacity: 0;
  pointer-events: none;
  margin-top: 0px;
}
</style>
